var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m_goodscollect"},[_c('mt-header',{attrs:{"title":"展商收藏"}},[_c('span',{attrs:{"slot":"left"},on:{"click":function (){ return this$1.$router.back(); }},slot:"left"},[_c('i',{staticClass:"iconfont icon-left"}),_vm._v(" 返回 ")])]),_vm._v(" 展品收藏开发中，敬情期待...... ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }